import PropTypes from "prop-types"
import React from "react"
import Grid from "semantic-ui-react/dist/es/collections/Grid/Grid"
import Header from "semantic-ui-react/dist/es/elements/Header/Header"

const WorksheetHeader = ({ header, subHeader, children }) => (
  <Grid.Row className="WorksheetHeader">
    <Grid.Column style={{ paddingLeft: "3em" }}>
      {!children ? (
        <Header as="h1" style={{ margin: "0px" }}>
          {header}
          <Header.Subheader style={{ marginTop: ".7em" }}>
            {subHeader}
          </Header.Subheader>
        </Header>
      ) : (
        children
      )}
    </Grid.Column>
  </Grid.Row>
)

WorksheetHeader.propTypes = {
  header: PropTypes.string,
  subHeader: PropTypes.string
}

export default WorksheetHeader
